export const USER_COMPANY_LIST = '/api/user/common/userCompanyList';

export const PROJECT_ATTENDANCE = '/api/command/center/project/attendance';

export const PROJECT_CONTRACT = '/api/command/center/project/labor/contract';

export const PROJECT_PROGRESS = '/api/command/center/project/schedule';

export const PROJECT_OVERVIEW_CONTRACT = '/api/project/overview/getProjectInfo';

export const PROJECT_OVERVIEW_WORKER = '/api/project/overview/getProjectAttendance';

export const PROJECT_OVERVIEW_PROGRESS = '/api/project/overview/getProjectSchedule';

export const PROJECT_OVERVIEW_ATTENDANCE = '/api/project/overview/getAttendanceByMonth';

export const PROJECT_OVERVIEW_NEWS = '/api/project/overview/getNews';

export const PROJECT_TASK_TREE = '/api/project/split/list';

export const PROJECT_TASK_DETAIL = '/api/project/split/detail';

export const PROJECT_TASK_TIMELINE = '/api/acceptance/timeline/list';
